export default __webpack_public_path__ + "static/media/refin_large_slabs_09_2023.b3967ca2.pdf";